import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-6 gap-6" }
const _hoisted_2 = { class: "lg:col-span-2 md:col-span-3 col-span-6" }
const _hoisted_3 = { class: "lg:col-span-2 md:col-span-3 col-span-6" }
const _hoisted_4 = { class: "lg:col-span-2 md:col-span-3 col-span-6" }
const _hoisted_5 = { class: "md:col-span-3 col-span-6" }
const _hoisted_6 = { class: "md:col-span-3 col-span-6" }
const _hoisted_7 = { class: "col-span-6" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-6 border-t border-gray-200" }, null, -1)
const _hoisted_9 = { class: "col-span-6" }
const _hoisted_10 = { class: "flex items-center justify-end w-full space-x-3" }
const _hoisted_11 = { href: "/personnel/index/" }

import { ref, onMounted } from 'vue';

import ConfirmationModal from '@/components/modals/ConfirmationModal.vue';
import SuccessModal from '@/components/modals/SuccessModal.vue';

import TextInput from '@/components/inputs/TextInput.vue';

import Profile from "@/classes/Profile";
import assignValues from "@/helpers/assignValues"
import ButtonComponent from '@/components/buttons/ButtonComponent.vue'

import { errorResponse } from "@/helpers/errorMessage";

import Storage from "@/helpers/storage";
import { numberonly } from "@/components/composables/useNumberOnly";

import PageLoader from "@/components/loaders/PageLoader.vue";



export default /*#__PURE__*/_defineComponent({
  __name: 'FormSection',
  setup(__props) {


const showConfirmation = ref<boolean>(false);
const showSuccess = ref<boolean>(false);
const loading = ref<boolean>(false);

const errors = ref<any>();

const storage = new Storage();

const form = ref<{
    email: string;
    last_name: string;
    first_name: string;
    middle_name: string;
    mobile_number: string;
    home_address: string;
    is_temporary: boolean;
    department_id: any;
    office_id: any;
    role_id: any;
    position_id: any;
}>({
    email: "",
    last_name: "",
    first_name: "",
    middle_name: "",
    mobile_number: "",
    home_address: "",
    is_temporary: false,
    department_id: "",
    office_id: "",
    position_id: "",
    role_id: "",
});

const init = (): void => {
    Profile.view()
        .then(({ data }) => {
            form.value = assignValues(form.value, data.item);
        })
        .catch((error: any) => {
            console.log(error)
        })
}

const submit = (): void => {
    showConfirmation.value = false
    Profile.edit(form.value).then(() => {
        showSuccess.value = true;
        updateProfile();
    })
    .catch((error: any) => {
        errors.value = errorResponse(error.response?.data?.errors)
    })
}

const updateProfile = (): void => {
    let user = JSON.parse(storage.get('user'));
    user = assignValues(user, form.value);

    storage.set('user', JSON.stringify(user));
    console.log(storage.get('user'));
}

onMounted(() => {
    init()
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("form", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(TextInput, {
          type: "text",
          label: "Last Name",
          placeholder: "Last name",
          name: "last_name",
          id: "last_name",
          modelValue: form.value.last_name,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.last_name) = $event)),
          error: errors.value?.last_name,
          required: ""
        }, null, 8, ["modelValue", "error"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(TextInput, {
          type: "text",
          label: "First Name",
          placeholder: "First name",
          name: "first_name",
          id: "first_name",
          modelValue: form.value.first_name,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.first_name) = $event)),
          error: errors.value?.first_name,
          required: ""
        }, null, 8, ["modelValue", "error"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(TextInput, {
          type: "text",
          label: "Middle Name",
          placeholder: "Middle name",
          name: "middle_name",
          id: "middle_name",
          modelValue: form.value.middle_name,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.middle_name) = $event)),
          error: errors.value?.middle_name
        }, null, 8, ["modelValue", "error"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(TextInput, {
          type: "email",
          label: "Email Address",
          placeholder: "Email address",
          name: "email_address",
          id: "email_address",
          modelValue: form.value.email,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.email) = $event)),
          error: errors.value?.email,
          required: ""
        }, null, 8, ["modelValue", "error"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(TextInput, {
          type: "tel",
          label: "Phone Number",
          placeholder: "Phone number",
          name: "phone_number",
          id: "phone_number",
          add_on_left: true,
          add_on_text: "+63",
          maxlength: 10,
          onKeypress: _unref(numberonly),
          modelValue: form.value.mobile_number,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.mobile_number) = $event)),
          error: errors.value?.mobile_number,
          required: ""
        }, null, 8, ["onKeypress", "modelValue", "error"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(TextInput, {
          label: "Address",
          placeholder: "Address",
          name: "address",
          id: "address",
          modelValue: form.value.home_address,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.value.home_address) = $event)),
          error: errors.value?.home_address,
          required: ""
        }, null, 8, ["modelValue", "error"])
      ]),
      _hoisted_8,
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("a", _hoisted_11, [
            _createVNode(ButtonComponent, { btnWidth: "quinary" }, {
              default: _withCtx(() => [
                _createTextVNode("Cancel")
              ]),
              _: 1
            })
          ]),
          _createVNode(ButtonComponent, {
            btnWidth: "primary",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (showConfirmation.value = true))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Save Changes")
            ]),
            _: 1
          })
        ]),
        _createVNode(ConfirmationModal, {
          typeTwo: true,
          show: showConfirmation.value,
          onCancel: _cache[7] || (_cache[7] = ($event: any) => (showConfirmation.value = false)),
          onConfirm: _cache[8] || (_cache[8] = ($event: any) => (submit())),
          "cancel-text": "Cancel",
          "action-text": "Confirm",
          title: "Save Details",
          content: "Are you sure you wish to save this detail?"
        }, null, 8, ["show"]),
        _createVNode(SuccessModal, {
          show: showSuccess.value,
          onConfirm: _cache[9] || (_cache[9] = ($event: any) => (showSuccess.value = false)),
          "action-text": "Close",
          title: "Profile Updated!",
          content: "Profile has been successfully updated"
        }, null, 8, ["show"])
      ])
    ]),
    _createVNode(PageLoader, { show: loading.value }, null, 8, ["show"])
  ], 64))
}
}

})